import React, { useEffect, useState } from 'react';
import { getCurrentUser, getAppUser } from '../../functions/utils'; // Import the utility function
import ExactLogo from '../../images/ExactLogo.png';
import TwinfieldLogo from '../../images/TwinfieldLogo.png';
import MultiversLogo from '../../images/MultiversLogo.png';
import FourPsLogo from '../../images/4PSLogo.png';
import SnelStartLogo from '../../images/SnelStartLogo.png';
import AfasLogo from '../../images/AfasLogo.png';
import EboekhoudenLogo from '../../images/EboekhoudenLogo.png';
import MicrosoftDynamicsLogo from '../../images/MicrosoftDynamicsLogo.png';
import XeroLogo from '../../images/XeroLogo.png';
import BestandLogo from '../../images/BestandLogo.png';
import AuditfileLogo from '../../images/AuditfileLogo.png';
import '../../css/ImportComponent.css';
import { useTranslations  } from '../utilities/TranslationContext';

function ImportSelectComponent() {
  const { getTranslation, translations } = useTranslations();
  const [currentUser, setCurrentUser] = useState([]);
  const [currentAppUser, setCurrentAppUser] = useState(false);

  useEffect(() =>{
    checkDevUser();
  }, []); 
  useEffect(() =>{
  }, [currentUser, currentAppUser]);

  async function checkDevUser(){
      var currentUser = await getCurrentUser();
      if(currentUser){
        setCurrentUser(currentUser);
        setCurrentAppUser(await getAppUser());
      }
      else{
        setTimeout(function(){
          return checkDevUser();
        }, 500);
      }
  }

  const exact_online = () => { 
    window.location.href = "https://importmodule.factview.nl/app?import=exactonline";
  }

  const exact_globe = () => { 
    window.location.href = "https://importmodule.factview.nl/app?import=exactglobe_select";
  }

  const twinfield = () => { 
    window.location.href = "https://importmodule.factview.nl/app?import=twinfield";
  }


  const multivers = () => { 
    window.location.href = "https://importmodule.factview.nl/app?import=multivers";
  }

  const four_ps = () => { 
    window.location.href = "https://importmodule.factview.nl/app?import=4PS";
  }

  const afas = () => { 
    window.location.href = "https://importmodule.factview.nl/app?import=afas";
  }

  const snelstart = () => { 
    window.location.href = "https://importmodule.factview.nl/app?import=snelstart";
  }
  
  const eboekhouden = () => { 
    window.location.href = "https://importmodule.factview.nl/app?import=eboekhouden";
  }
  const microsoft_dynamics = () => { 
    window.location.href = "https://importmodule.factview.nl/app?import=microsoftdynamics";
  }
  const xero = () => { 
    window.location.href = "https://importmodule.factview.nl/app?import=xero";
  } 
  const camt_bestand = () => { 
    window.location.href = "https://importmodule.factview.nl/app?import=camt";
  }
  const auditfile_bestand = () => { 
    window.location.href = "https://importmodule.factview.nl/app?import=auditfile";
  }
  return (
    <div className="import-container">
      <div className="import-header">
        <div className="import-header-title">
          <p>Imports</p>
        </div>
      </div>
      <div className="import-body">
        <div className="import-body-title">
          <p>{getTranslation("import_ImpComponentSubtitle")}</p>
        </div>
        <div className="component-container">
          <div className="import-component">
            <div className="component-logo">           
              <img src={ExactLogo} className="import-logo" alt="logo" />
            </div>
            <div className="component-content">
              <div className="component-title">
                <p>Exact online</p>
              </div>
              <div className="component-desc">
                <p>{getTranslation("import_ExactImportDesc")}</p> 
              </div>
            </div>
            <div className="component-button">
              <button className="import-component-btn hover" onClick={() => exact_online()}>{getTranslation("import_StartImport")}</button>
            </div>
          </div>
          <div className="import-component">
            <div className="component-logo">           
              <img src={ExactLogo} className="import-logo" alt="logo" />
            </div>
            <div className="component-content">
              <div className="component-title">
                <p>Exact Globe+</p>
              </div>
              <div className="component-desc">
                <p>{getTranslation("import_ExactGlobeImportDesc")}</p> 
              </div>
            </div>
            <div className="component-button">
              <button className="import-component-btn hover" onClick={() => exact_globe()}>{getTranslation("import_StartImport")}</button>
            </div>
          </div>
          <div className="import-component">
            <div className="component-logo">
              <img src={TwinfieldLogo} className="import-logo" alt="logo" />
            </div>
            <div className="component-content">
              <div className="component-title">
                <p>Twinfield</p>
              </div>
              <div className="component-desc">
                <p>{getTranslation("import_TwinfieldImportDesc")}</p> 
              </div>
            </div>
            <div className="component-button">
              <button className="import-component-btn hover" onClick={() => twinfield()}>{getTranslation("import_StartImport")}</button>
            </div>
          </div>
          <div className="import-component">
            <div className="component-logo">
              <img src={MultiversLogo} className="import-logo" alt="logo" />
            </div>
            <div className="component-content">
              <div className="component-title">
                <p>Multivers</p>
              </div>
              <div className="component-desc">
                <p>{getTranslation("import_MultiversDesc")}</p> 
              </div>
            </div>
            <div className="component-button">
              <button className="import-component-btn hover" onClick={() => multivers()}>{getTranslation("import_StartImport")}</button>
            </div>
          </div>
          {(currentAppUser.integration_4ps == 1) ?
          <div className="import-component">
            <div className="component-logo">
              <img src={FourPsLogo} className="import-logo" alt="logo" />
            </div>
            <div className="component-content">
              <div className="component-title">
                <p>4PS</p>
              </div>
              <div className="component-desc">
                <p>{getTranslation("import_4psDesc")}</p> 
              </div>
            </div>
            <div className="component-button">
              <button className="import-component-btn hover" onClick={() => four_ps()}>{getTranslation("import_StartImport")}</button>
            </div>
          </div> 
          : null}
          <div className="import-component">
            <div className="component-logo">
              <img src={AfasLogo} className="import-logo" alt="logo" />
            </div>
            <div className="component-content">
              <div className="component-title">
                <p>AFAS</p>
              </div>
              <div className="component-desc">
                <p>{getTranslation("import_AfasImportDesc")}</p> 
              </div>
            </div>
            <div className="component-button">
              <button className="import-component-btn hover" onClick={() => afas()}>{getTranslation("import_StartImport")}</button>
            </div>
          </div> 
          <div className="import-component">
            <div className="component-logo">
              <img src={SnelStartLogo} className="import-logo" alt="logo" />
            </div>
            <div className="component-content">
              <div className="component-title">
                <p>SnelStart</p>
              </div>
              <div className="component-desc">
                <p>{getTranslation("import_SnelStartDesc")}</p> 
              </div>
            </div>
            <div className="component-button">
              <button className="import-component-btn hover" onClick={() => snelstart()}>{getTranslation("import_StartImport")}</button>
            </div>
          </div> 
          {(currentUser == 819 || currentUser == 2 || currentUser == 1269 || currentUser == 1255 || currentUser == 1227 || currentUser == 1115) ?
          <div className="import-component">
            <div className="component-logo">
              <img src={BestandLogo} className="import-logo" alt="logo" />
            </div>
            <div className="component-content">
              <div className="component-title">
                <p>CAMT Bestand</p>
              </div>
              <div className="component-desc">
                <p>Importeer CAMT.053 bestand gegevens</p> 
              </div>
            </div>
            <div className="component-button">
              <button className="import-component-btn hover" onClick={() => camt_bestand()}>{getTranslation("import_StartImport")}</button>
            </div>
          </div> 
          : null}
           {/* {(currentUser == 819) ? */}
          <div className="import-component">
            <div className="component-logo">
              <img src={AuditfileLogo} className="import-logo" alt="logo" />
            </div>
            <div className="component-content">
              <div className="component-title">
                <p>Auditfile Bestand</p>
              </div>
              <div className="component-desc">
                <p>Importeer Auditfile bestand gegevens</p> 
              </div>
            </div>
            <div className="component-button">
              <button className="import-component-btn hover" onClick={() => auditfile_bestand()}>{getTranslation("import_StartImport")}</button>
            </div>
          </div> 
          {/* : null} */}
          {(currentUser == 819) ?
          <div className="import-component">
            <div className="component-logo">
              <img src={EboekhoudenLogo} className="import-logo" alt="logo" />
            </div>
            <div className="component-content">
              <div className="component-title">
                <p>Eboekhouden</p>
              </div>
              <div className="component-desc">
                <p>{getTranslation("import_EboekhoudenDesc")}</p> 
              </div>
            </div>
            <div className="component-button">
              <button className="import-component-btn hover" onClick={() => eboekhouden()}>{getTranslation("import_StartImport")}</button>
            </div>
          </div> 
          : null}
          {(currentUser == 819) ?
          <div className="import-component">
            <div className="component-logo">
              <img src={MicrosoftDynamicsLogo} className="import-logo" alt="logo" />
            </div>
            <div className="component-content">
              <div className="component-title">
                <p>Microsoft Dynamics</p>
              </div>
              <div className="component-desc">
                <p>{getTranslation("import_MicrosoftDynamicsDesc")}</p> 
              </div>
            </div>
            <div className="component-button">
              <button className="import-component-btn hover" onClick={() => microsoft_dynamics()}>{getTranslation("import_StartImport")}</button>
            </div>
          </div> 
          : null}
            {(currentUser == 819) ?
          <div className="import-component">
            <div className="component-logo">
              <img src={XeroLogo} className="import-logo" alt="logo" />
            </div>
            <div className="component-content">
              <div className="component-title">
                <p>Xero</p>
              </div>
              <div className="component-desc">
                <p>{getTranslation("import_XeroDesc")}</p> 
              </div>
            </div>
            <div className="component-button">
              <button className="import-component-btn hover" onClick={() => xero()}>{getTranslation("import_StartImport")}</button>
            </div>
          </div> 
          : null}
        </div> 
      </div>
    </div>
  );
}

export default ImportSelectComponent;
